import { Device, DeviceInfo } from '@capacitor/device'
import { useEffect, useState } from 'react'

import { useMessage } from '@/core'

export const useDeviceInfo = () => {
  const [loading, setLoading] = useState(false)
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo | null>(null)
  const { showError } = useMessage()

  useEffect(() => {
    setLoading(true)
    Device.getInfo()
      .then(r => setDeviceInfo(r))
      .catch(e => showError(e))
      .finally(() => setLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return { loading, deviceInfo }
}

/**
 * @description detect browser name by user agent.
 */
export function browserDetect() {
  const { userAgent } = navigator
  if (userAgent.match(/chrome|chromium|crios/i)) {
    return 'Chrome'
  }
  if (userAgent.match(/firefox|fxios/i)) {
    return 'Firefox'
  }
  if (userAgent.match(/safari/i)) {
    return 'Safari'
  }
  if (userAgent.match(/opr\//i)) {
    return 'Opera'
  }
  if (userAgent.match(/edg/i)) {
    return 'Edge'
  }
  return null
}
